/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Context_ClientInputs */

const en_task_field_context_client = /** @type {(inputs: Task_Field_Context_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client`)
};

const pt_br2_task_field_context_client = /** @type {(inputs: Task_Field_Context_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente`)
};

/**
* | output |
* | --- |
* | "Client" |
*
* @param {Task_Field_Context_ClientInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_context_client = /** @type {((inputs?: Task_Field_Context_ClientInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Context_ClientInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_context_client(inputs)
	return pt_br2_task_field_context_client(inputs)
});